import { fetchActions } from "app/store/actions/actionsUserSlice";
import { isCarrier } from "app/services/LoginService";

/** Multiline text fields (outlined) like TripInvoicingSendInvoiceView recipient entry. */
const BROKER_OUTREACH_BLOCKLIST_ITEMS = [
	{
		type: "message",
		builder: () =>
			"Block automated load booking outreach to specific broker emails or phone numbers. Enter one address or number per line, or separate entries with commas (same style as invoice email recipients).",
	},
	{
		key: "broker_contact_blocklist_text",
		type: "text",
		label: "Blocked broker contact emails",
		placeholder: "Recipients (one per line or comma-separated)",
		multiline: { rows: 4 },
		field: { noErrorMessage: true, classes: { root: "mb-14 mt-6" } },
		description: "We will not send booking or broker tracking emails to these addresses.",
	},
	{
		key: "broker_phone_blocklist_text",
		type: "text",
		label: "Blocked broker phone numbers",
		placeholder: "5551234567",
		multiline: { rows: 4 },
		field: { noErrorMessage: true, classes: { root: "mb-14 mt-6" } },
		description: "We will not place autobooking calls to these numbers (digits; US numbers 10 or 11 digits).",
	},
];

const brokers = {
	urlGET: "api/profile/carriers/:carrierId/brokers",
	urlPUT: "api/profile/carriers/:carrierId/brokers",
	idKey: "_id",
	triggerEvent: "onboardingRevision",
	listenEvent: "onboardingRevision",
	header: {
		edit: { label: "Edit Brokers" },
	},
	messages: { edit: { success: "Successfully Saved Information" }, create: { sameAs: "edit" } },
	content: {
		view: {
			items: [
				{
					key: "ops_onboarded_brokers",
					type: "autocomplete",
					label: "Preferred Brokers",
					translate: "ONBOARDED_BROKERS",
					autocomplete: {
						provider: "smarthop",
						url: "api/consts/brokers",
						multiple: true,
						preloadDefault: true,
					},
				},
				{
					key: "ops_blacklisted_brokers",
					type: "autocomplete",
					label: "Blacklisted Brokers",
					translate: "BLACKLISTED_BROKERS",
					autocomplete: {
						provider: "smarthop",
						url: "api/consts/brokers",
						multiple: true,
						preloadDefault: true,
					},
				},
				...BROKER_OUTREACH_BLOCKLIST_ITEMS,
				{ type: "action", action: "SUBMIT" },
			],
		},
		create: {
			sameAs: "edit",
		},
		edit: {
			items: [
				{
					key: "ops_onboarded_brokers",
					type: "autocomplete",
					label: "Preferred Brokers",
					disabled: "",
					autocomplete: {
						provider: "smarthop",
						url: "api/consts/brokers",
						multiple: true,
						preloadDefault: true,
					},
					rules: {
						disabled: {
							ifNotEmptyRef: "ops_no_onboarded_brokers",
						},
					},
				},
				{
					key: "ops_no_onboarded_brokers",
					type: "checkbox",
					label: "No Preferred Brokers",
					translate: "NO_ONBOARDER-BROKERS",
					rules: {
						disabled: {
							ifNotEmptyRef: "ops_onboarded_brokers",
						},
					},
				},
				{
					key: "ops_blacklisted_brokers",
					type: "autocomplete",
					label: "Blacklisted Brokers",
					autocomplete: {
						provider: "smarthop",
						url: "api/consts/brokers",
						multiple: true,
						preloadDefault: true,
					},
					rules: {
						disabled: {
							ifNotEmptyRef: "ops_no_blacklisted_brokers",
						},
					},
				},
				{
					key: "ops_no_blacklisted_brokers",
					type: "checkbox",
					label: "No Blacklisted Brokers",
					rules: {
						disabled: {
							ifNotEmptyRef: "ops_blacklisted_brokers",
						},
					},
				},
				...BROKER_OUTREACH_BLOCKLIST_ITEMS,
				{ type: "action", action: "SUBMIT" },
			],
			onFinished: (data, dispatch) => {
				if (isCarrier()) {
					dispatch(fetchActions({ carrierId: data.id }));
				}
			},
		},
	},
};

export default brokers;
